import React from "react"
import illustration from '../images/illustrazione-capitolo-3.svg'
import frecciaWhite from '../images/freccia-white.svg'

const Page10 = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="h-100 grid-cols-12 xl:grid-cols-12">
      <div className='col-1'>
      </div>
      <div className='col-5'>
        <div className='lg:mt-13 xl:mt-11 font-uppercase font-18 line-height-22'>
          EDISON FLEET AUDIT
        </div>
        <div className='mt-3 pb-5 lg:font-62 xl:font-50 font-family-acumin lg:line-height-70 xl:line-height-58 font-weight-900'>
          Fare il pieno, ma di energia
        </div>
        <div className='font-22 line-height-28' style={{ width: 450 }}>
          Ecco Fleet Audit, il servizio di Edison <br />
          che favorisce la svolta green nelle flotte <br />
          aziendali, puntando tutto sull’elettrico.
        </div>
        <div className='mt-12 d-flex justify-content-between' style={{ width: 400 }}>
          <div className='font-family-acumin font-20'>
            03 / 04
          </div>
          <div className='mt-1'>
            <img src={frecciaWhite} alt='Freccia white' />
          </div>
        </div>
      </div>
      <div className='col-6'>
        <div className='lg:mt-13 xl:mt-11 mb-5'>
          <img src={illustration} alt='La mobilità elettrica' className='w-100 h-100' style={{ objectFit: 'contain'}} />
        </div>
      </div>

    </div>
  )
}

export default Page10
